import { formatterDate, formatterTime } from "./misc";

export function formatDate(date) {
  return formatterDate.format(date);
}

export function formatTime(date) {
  return formatterTime.format(date).toUpperCase();
}

//converts from degrees to radians.
function toRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

//converts from radians to degrees.
function toDegrees(radians) {
  return (radians * 180) / Math.PI;
}

//adds bearing data to an array
export function addBearing(gpsArray) {
  if (gpsArray.length === 1) return gpsArray;

  for (let i = 0; i < gpsArray.length - 1; i++) {
    gpsArray[i].bearingValue = calculateBearing(gpsArray[i], gpsArray[i + 1]);
    gpsArray[i].direction = calculateDirection(gpsArray[i]);
  }
  //setting direction and row of last index to the previous known direction
  gpsArray[gpsArray.length - 1].bearingValue =
    gpsArray[gpsArray.length - 2].bearingValue;
  gpsArray[gpsArray.length - 1].direction =
    gpsArray[gpsArray.length - 2].direction;
  //if vehicle is not moving then get last bearingValue & direction from when vehicle was moving and cascade through non traveling rows
  gpsArray.forEach((row, i) => {
    if (i === 0) return; //dont want to set if first index in array is 0 km/h
    if (row.speed === "0 km/h") {
      row.bearingValue = gpsArray[i - 1].bearingValue;
      row.direction = gpsArray[i - 1].direction;
    }
  });
  return gpsArray;
}

//calculates bearing based on a start/end latitude and longitude
function calculateBearing(startPoint, endPoint) {
  const startLat = toRadians(startPoint.latitude);
  const startLng = toRadians(startPoint.longitude);
  const destLat = toRadians(endPoint.latitude);
  const destLng = toRadians(endPoint.longitude);

  const y = Math.sin(destLng - startLng) * Math.cos(destLat);
  const x =
    Math.cos(startLat) * Math.sin(destLat) -
    Math.sin(startLat) * Math.cos(destLat) * Math.cos(destLng - startLng);
  const bearing = toDegrees(Math.atan2(y, x));

  return (bearing + 360) % 360;
}

function calculateDirection(row) {
  if (row.bearingValue >= 0 && row.bearingValue <= 360) {
    const bearingSlice = 360 / 16;
    const slices = [
      "N",
      "NNE",
      "NE",
      "ENE",
      "E",
      "ESE",
      "SE",
      "SSE",
      "S",
      "SSW",
      "SW",
      "WSW",
      "W",
      "WNW",
      "NW",
      "NNW",
      "N",
    ];
    let sliceStart = 0 - bearingSlice / 2;
    let index = 0;
    while (sliceStart < row.bearingValue) {
      if (row.bearingValue <= sliceStart + bearingSlice) return slices[index];
      sliceStart += bearingSlice;
      index++;
    }
  } else {
    return "";
  }
}

export const exportedForTesting = {
  toRadians,
  toDegrees,
  calculateBearing,
  calculateDirection,
};
